import styled from 'styled-components'

export const MainPanelSlot = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`
MainPanelSlot.displayName = 'MainPanelSlot'
